<template>
  <Drawer title="OCR图文识别" width="400" :mask="false" v-model="OCRState">
    <Upload
        multiple
        :show-upload-list="false"
        type="drag"
        :on-success="uploadSuccess"
        :headers="{GroupId:groupId,Con:'R',Fun:'upload_file',UserLogin:phoneNumber,UserToken:userToken,Ver:'v1'}"
        :data="{MenuId:menuId,UserId:userId}"
        :action="getServerURL('default',true)">
      <div style="padding: 20px 0">
        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
        <p>点击或拖拽文件到此处完成上传</p>
      </div>
    </Upload>
    <p style="padding: 15px"></p>
    <p>识别后的文字如下：</p>
    <p style="padding: 10px"></p>
    <p v-for="(item,index) in text">{{item}}</p>
    <div style="position: absolute;bottom:15px;left: 15px">
      <Button style="margin-right: 8px" @click="OCRState = false">关闭</Button>
    </div>
  </Drawer>
</template>

<script>
  export default {
    name: "OCR",
    data:function () {
      return{
        text:[],
      }
    },
    methods:{
      uploadSuccess:function (response,file,fileList) {
        this.$Notice.success({
          title:'系统提示',
          desc:'文件上传成功，正在识别！'
        })
        this.OCRStart(response.Data.path)
      },
      OCRStart:function (src) {
        var _this = this
        _this.send({
          headers:'OCR/OCR',
          data:{
            path:src,
          },
          success:function (res) {
            _this.$set(_this,'text',res)
          }
        })
      }
    },
    computed:{
      OCRState:{
        get:function () {
          return this.$store.state.OCRState
        },
        set:function (val) {
          this.$store.state.OCRState = val
        }
      },
      phoneNumber:function () {
        return window.sessionStorage.phoneNumber
      },
      userToken:function () {
        return window.sessionStorage.userToken
      },
      groupId:function () {
        return window.sessionStorage.groupId
      },
      menuId:function () {
        return window.sessionStorage.menuId
      },
      userId:function () {
        return window.sessionStorage.userId
      },
    },
  }
</script>

<style scoped>

</style>